"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AirwebTicketLegacyTestService = void 0;
class AirwebTicketLegacyTestService {
    constructor(client) {
        this.client = client;
    }
    async request(method, data) {
        const requestConfig = { method, url: 'tests/request' };
        if (method === 'get' || method === 'GET')
            requestConfig.params = data;
        else
            requestConfig.data = data;
        const httpResponse = await this.client.http.request(requestConfig);
        return httpResponse.data.request;
    }
}
exports.AirwebTicketLegacyTestService = AirwebTicketLegacyTestService;
//# sourceMappingURL=test.service.js.map